import { Component, Input, OnInit } from '@angular/core';
import * as chartData from '../../../../shared/data/dashboard/default'
import { ChartOptions } from '../../../../shared/data/dashboard/default';

@Component({
  selector: 'app-recent-orders',
  templateUrl: './recent-orders.component.html',
  styleUrls: ['./recent-orders.component.scss']
})
export class RecentOrdersComponent implements OnInit {

  @Input() dataPin:any;

  public recentOrders: any; // Déclaration d'une propriété pour recentOrders


 
  public show : boolean = false
  constructor() { 

     this.recentOrders = {
      series: [],
      chart: {
        height: 290,
        type: "radialBar",
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        radialBar: {
          hollow: {
            margin: 0,
            size: "60%",
            background: "var(--recent-chart-bg)",
            image: undefined,
            imageOffsetX: 0,
            imageOffsetY: 0,
            position: "front",
            dropShadow: {
              enabled: true,
              top: 3,
              left: 0,
              blur: 4,
              opacity: 0.05,
            },
          },
          track: {
            background: "#F4F4F4",
            strokeWidth: "67%",
            margin: 0,
            dropShadow: {
              enabled: true,
              top: 0,
              left: 0,
              blur: 10,
              color: "#ddd",
              opacity: 1,
            },
          },
    
          dataLabels: {
            show: true,
            name: {
              offsetY: 30,
              show: true,
              color: "#888",
              fontSize: "17px",
              fontWeight: "500",
              fontFamily: "Rubik, sans-serif",
            },
            value: {
              formatter: function (val) {
                return parseInt(val);
              },
              offsetY: -8,
              color: "#111",
              fontSize: "36px",
              show: true,
            },
          },
        },
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "dark",
          type: "horizontal",
          shadeIntensity: 0.5,
          opacityFrom: 1,
          opacityTo: 1,
          colorStops: [
            {
              offset: 0,
              color: "#7366FF",
              opacity: 1,
            },
            {
              offset: 20,
              color: "#3EA4F1",
              opacity: 1,
            },
            {
              offset: 100,
              color: "#FFFFFF",
              opacity: 1,
            },
          ],
        },
      },
      stroke: {
        lineCap: "round",
      },
      labels: ["Points"],
      responsive: [
        {
          breakpoint: 1840,
          options: {
            chart: {
              height: 260,
            },
          },
        },
        {
          breakpoint: 1700,
          options: {
            chart: {
              height: 250,
            },
          },
        },
        {
          breakpoint: 1660,
          options: {
            chart: {
              height: 230,
              dataLabels: {
                name: {
                  fontSize: "15px",
                },
              },
            },
          },
        },
        {
          breakpoint: 1561,
          options: {
            chart: {
              height: 275,
            },
          },
        },
        {
          breakpoint: 1400,
          options: {
            chart: {
              height: 360,
            },
          },
        },
        {
          breakpoint: 1361,
          options: {
            chart: {
              height: 300,
            },
          },
        },
        {
          breakpoint: 1200,
          options: {
            chart: {
              height: 230,
            },
          },
        },
        {
          breakpoint: 1007,
          options: {
            chart: {
              height: 240,
            },
          },
        },
        {
          breakpoint: 600,
          options: {
            chart: {
              height: 230,
            },
          },
        },
      ],
    };
  }
  ngOnInit(): void {
    if (this.dataPin) {
      // Mise à jour de la série de recentOrders avec la série de dataPin
      this.recentOrders.series = this.dataPin.series;
    }
  }

  toggle(){
    this.show = !this.show
  }
}
